import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, SimpleChange} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EmailTemplateService} from '../../admin-core/apiservices';
import {EmailTemplateModel, RequestParamModel} from '../../admin-core/models';
import * as Editor from '@ckeditor/ckeditor5-build-classic';
import {DomSanitizer} from '@angular/platform-browser';
import {Constants} from '../../admin-core/constants';
import {EmailBodyUpdatePopupComponent} from '../../quote-order-sample-core/email-body-update-popup/email-body-update-popup.component';
import {CommonSingleInputFormComponent} from '../../admin-core/components/common-single-input-form/common-single-input-form.component';
import {FormAutofocusDirective} from '../../shared/directives/form-autofocus.directive';

@Component({
  hostDirectives: [FormAutofocusDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
    selector: 'app-mail-template-edit-on-status-change',
    templateUrl: './mail-template-edit-on-status-change.component.html',
    styleUrls: ['./mail-template-edit-on-status-change.component.css', '../../app.component.css']
})
export class MailTemplateEditOnStatusChangeComponent implements OnInit {
    @Input() keyName!: string;
    @Input() titleName!: string;
    @Input() quoteId!: string;
    emailForm!: UntypedFormGroup;
    hasFormError = false;
    submitted: boolean = false;
    isLoading: boolean = false;
    public Editor = Editor;
    isSecondModel = false;
    emailModel!: EmailTemplateModel;
    config = {
        placeholder: '',
        tabsize: 2,
        height: '200px',
        dialogsInBody: 'true',
        toolbar: [
            ['misc', ['codeview', 'undo', 'redo']],
            ['fontsize', ['fontsize',]],
            ['style', ['bold', 'italic', 'underline']],
            ['para', ['paragraph',]],
            ['insert', ['link',]]
        ],
    }
    constant = Constants
    emails!: UntypedFormArray;
    isDisplayRecipient = false;
    isDisplayAddRecipientOption = false;
    isSendCopyToSalesRepresentative: boolean = false;
    currentYear: number = new Date().getFullYear();

    constructor(
        public activeModel: NgbActiveModal,
        public emailTemplateService: EmailTemplateService,
        public fb: UntypedFormBuilder,
        public changeDetection: ChangeDetectorRef,
        public sanitizer: DomSanitizer,
        public ngbService: NgbModal
    ) {
    }

    get f() {
        return this.emailForm.controls;
    }

    get fe() {
        return <UntypedFormArray>this.emailForm.get('emails');
    }

    toggleRecipients() {
        if (this.isDisplayRecipient == false) {
            this.emails = this.emailForm.get('emails') as UntypedFormArray
            this.emails.push(this.createEmail());
            this.changeDetection.detectChanges()

            this.isDisplayRecipient = true;
        } else {
            let frmArray = this.emailForm.get('emails') as UntypedFormArray
            frmArray.clear();
            this.isDisplayRecipient = false;

            this.changeDetection.detectChanges()
        }
    }

    initForm() {
        this.emailForm = this.fb.group({
            title: new UntypedFormControl(null, [Validators.required]),
            body: new UntypedFormControl('', [Validators.required]),
            emails: new UntypedFormArray([], []),
            is_send_copy_to_sales_representative: new UntypedFormControl(false, []),
        })
    }

    onChange($event: any) {
        this.isSendCopyToSalesRepresentative = $event.target.checked;
    }

    createEmail(): UntypedFormGroup {
        return this.fb.group({
            email: new UntypedFormControl('', [Validators.required, Validators.pattern(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)]),
        });
    }

    emailsArray() {
        return this.emailForm.get('emails') as UntypedFormArray;
    }

    ngOnInit(): void {
        const emailTemplateKeyArray = Constants.EMAIL_TEMPLATE_KEY_NAME_FOR_ADD_RECIPIENT;
        if (this.keyName && emailTemplateKeyArray.includes(this.keyName)) {
            this.isDisplayAddRecipientOption = true;
        }

        this.getEmailTemplates();
        this.initForm()
    }

    addNewEmail() {
        this.emails = this.emailForm.get('emails') as UntypedFormArray
        this.emails.push(this.createEmail());
        this.changeDetection.detectChanges()
    }

    removeNewEmail(index: number) {
        this.fe.removeAt(index)
    }

    onSubmit() {
        this.submitted = true;
        this.emailForm.get('is_send_copy_to_sales_representative')?.setValue(this.isSendCopyToSalesRepresentative);
        if (this.emailForm.valid && this.fe.valid) {
            this.activeModel.close({data: this.emailForm.value})
        }
        return false;
    }

    getEmailTemplates() {
        this.isLoading = true;
        if (this.keyName == Constants.EMAIL_TEMPLATE_TRADE_USER_CARRIER_ADDED_KEY_NAME) {
            this.emailTemplateService.getEmailTemplateDetailWithParam(Constants.EMAIL_TEMPLATE_TRADE_USER_CARRIER_ADDED_ID + '?quote_id=' + this.quoteId).subscribe((data: EmailTemplateModel) => {
                this.isLoading = false;
                if (data) {
                    this.emailModel = data
                    if (this.emailModel.body) {
                      this.emailModel.body = this.emailModel.body
                        .replace(/##WALLINGIMAGEPATH##/g, this.constant.EMAIL_TEMPLATE_IMAGES.WALLING_IMAGE)
                        .replace(/##FLOORINGIMAGEPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.FLOORING_IMAGE)
                        .replace(/##RESOURCEHUBICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.RESOURCE_HUB_ICON)
                        .replace(/##SUPPORTICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.SUPPORT_ICON )
                        .replace(/##REWARDSICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.REWARDS_ICON )
                        .replace(/##SAMPLESICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.SAMPLE_ICON );
                    }
                    this.patchValue()
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
            });
        } else {
            const requestParamModel = new RequestParamModel();
            requestParamModel.addDefaultFilter('key', this.keyName, 'number');
            this.emailTemplateService.getEmailTemplates(requestParamModel).subscribe((response: any) => {

                this.isLoading = false;
                if (response) {
                    this.emailModel = response.data[0]
                    if (this.emailModel.body) {
                      this.emailModel.body = this.emailModel.body
                        .replace(/##WALLINGIMAGEPATH##/g, this.constant.EMAIL_TEMPLATE_IMAGES.WALLING_IMAGE)
                        .replace(/##FLOORINGIMAGEPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.FLOORING_IMAGE)
                        .replace(/##RESOURCEHUBICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.RESOURCE_HUB_ICON)
                        .replace(/##SUPPORTICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.SUPPORT_ICON )
                        .replace(/##REWARDSICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.REWARDS_ICON )
                        .replace(/##SAMPLESICONPATH##/g,this.constant.EMAIL_TEMPLATE_IMAGES.SAMPLE_ICON );
                    }
                    this.patchValue()
                }
            }, (error: HttpErrorResponse) => {
                this.isLoading = false;
            })
        }
    }

    patchValue() {
        this.emailForm.patchValue({
            title: this.emailModel?.title,
            body: this.emailModel.body
        })

        this.changeDetection.detectChanges()
    }

    titleUpdate() {
        this.isSecondModel = true;
        const modelInstance = this.ngbService.open(CommonSingleInputFormComponent, {
            windowClass: 'email-title',
            centered: false,
        })
        modelInstance.componentInstance.MainModule = Constants.EMAIL_TITLE_UPDATE.MAIN_HEADING;
        modelInstance.componentInstance.oldData = {value: this.emailModel.title}
        modelInstance.componentInstance.fieldData = {
            label: Constants.EMAIL_TITLE_UPDATE.LABEL,
            validation: {
                required: true,
                message: Constants.EMAIL_TITLE_UPDATE.REQUIRED_ERROR_MESSAGE
            }
        };

        modelInstance.closed.subscribe((data) => {
            this.isSecondModel = false;
            if (data) {
                let json = {
                    name: data.field
                }
                this.emailForm.patchValue({
                    title: data.field
                })
                this.emailModel.title = data.field
            }
        })
    }

    cancel() {
        this.activeModel.close(false)
    }

    bodyUpdate() {
        let options = {};

        if (this.keyName == 'trade-user-carrier-added') {
            options = {
                windowClass: 'mail-edit-carrier',
                centered: false,
                size: 'xl'
            }
        } else {
            options = {
                windowClass: 'mail-edit-model',
                centered: false
            }
        }

        this.isSecondModel = true;
        const instance = this.ngbService.open(EmailBodyUpdatePopupComponent, options);
        instance.componentInstance.emailModel = this.emailModel;
        instance.closed.subscribe((data) => {
            this.isSecondModel = false;
            if (data) {
                if (data.body) {
                    this.emailForm.patchValue({
                        body: data.body
                    })
                    this.emailModel.body = data.body
                }
            }
        })
    }
}
